import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import keyboardjs from 'keyboardjs';
import PubSub from 'pubsub-js';

import DashboardMenu from '../../DashboardMenu';
import Container from './Container';
import MenuContainer from './MenuContainer';
import Button from './Button';

@observer
export default class DropMenu extends Component {
  @observable isOpen = false;
  @action toggle = () => (this.isOpen = !this.isOpen);
  @action close = () => (this.isOpen = false);

  constructor(props) {
    super(props);
    keyboardjs.bind('esc', this.close);
    this.bodyClick = PubSub.subscribe('body-click', this.close);
  }

  componentWillUnmount() {
    keyboardjs.unbind('esc', this.close);
    PubSub.unsubscribe(this.bodyClick);
  }

  stopPropagation = event => event.stopPropagation();

  render() {
    return (
      <Container onClick={this.stopPropagation}>
        <Button onClick={this.toggle} open={this.isOpen} />
        <MenuContainer open={this.isOpen}>
          <DashboardMenu />
        </MenuContainer>
      </Container>
    );
  }
}
